import { useGetPremiumFeatures } from '@/queries/permissions/useGetPremiumFeatures'
import { usePremiumFeaturesStore } from '@/stores/permissions/premiumFeatures'
import { useEffect } from 'react'

export function usePremiumFeaturesFetcher() {
  const { data } = useGetPremiumFeatures()
  const { actions } = usePremiumFeaturesStore()

  useEffect(() => {
    if (data) {
      actions.setPremiumFeatures(data.features)
      actions.setStatus(data.status)
      if (data.accountCreatedAt) actions.setAccountCreatedAt(new Date(data.accountCreatedAt))
      if (data.paymentIssue) actions.setPaymentIssue(data.paymentIssue)
    }
  }, [actions, data])
}
